import { render } from "./UserCard.vue?vue&type=template&id=44fad792"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/User/Home/UserCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44fad792"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44fad792', __exports__)) {
    api.reload('44fad792', __exports__)
  }
  
  module.hot.accept("./UserCard.vue?vue&type=template&id=44fad792", () => {
    api.rerender('44fad792', render)
  })

}


export default __exports__